var map = {
	"./barcode-document-list/barcode-document-list.module": [
		"./src/app/barcode-document-list/barcode-document-list.module.ts",
		"common",
		"barcode-document-list-barcode-document-list-module"
	],
	"./barcode-list/barcode-list.module": [
		"./src/app/barcode-list/barcode-list.module.ts",
		"common",
		"barcode-list-barcode-list-module"
	],
	"./barcode-result-list/barcode-result-list.module": [
		"./src/app/barcode-result-list/barcode-result-list.module.ts",
		"common",
		"barcode-result-list-barcode-result-list-module"
	],
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		"common",
		"home-home-module"
	],
	"./html5-camera/html5-camera.module": [
		"./src/app/html5-camera/html5-camera.module.ts",
		"common",
		"html5-camera-html5-camera-module"
	],
	"./idcard-scan-results/idcard-scan-results.module": [
		"./src/app/idcard-scan-results/idcard-scan-results.module.ts",
		"common",
		"idcard-scan-results-idcard-scan-results-module"
	],
	"./image-results/image-results.module": [
		"./src/app/image-results/image-results.module.ts",
		"image-results-image-results-module"
	],
	"./image-view/image-view.module": [
		"./src/app/image-view/image-view.module.ts",
		"image-view-image-view-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;